import {
	CompanyCountry,
	CompanyType
} from '@common/enums/company.enums'

export const COMPANY_TYPES = Object.values(CompanyType)

export const COMPANY_TYPES_SALES_COMPANY = [CompanyType.DISTRIBUTOR, CompanyType.END_USER]

export const COMPANY_TYPES_DIVISION = [CompanyType.DISTRIBUTOR, CompanyType.END_USER, CompanyType.SALES_COMPANY]

export const COMPANY_COUNTRIES = Object.values(CompanyCountry)
